export const getLastUpdatedUserProfile = state => state.settings.lastUpdatedUserProfile;
export const getRowsUserProfile = state => state.settings.rowsForUserProfile;
export const getUserProfileInitialised = state => state.settings.initialisedUserProfile;
export const getAppConfig = state => state.settings.appConfig;
export const getAppConfigSaving = state => state.settings.appConfigSaving;
export const getAppConfigSaveError = state => state.settings.appConfigSaveError;
export const getAppConfigSaved = state => state.settings.appConfigSaved;
